import TextField from "@mui/material/TextField";

export default function ProductFilterField({ children, select = false, sx, width, ...props }) {
  return (
    <TextField
      {...props}
      select={select}
      variant="outlined"
      size="small"
      sx={(theme) => ({
        width: width ?? { xs: "100%", sm: theme.product.field.filterWidth },
        "& .MuiOutlinedInput-root": {
          alignItems: "center",
          bgcolor: theme.palette.background.paper,
          borderRadius: theme.shape.radii.pill,
          color: theme.palette.text.primary,
          fontSize: theme.typography.body2.fontSize,
          fontWeight: 400,
          height: `${theme.product.field.filterHeight}px !important`,
          minHeight: `${theme.product.field.filterHeight}px !important`,
          pr: select ? 1 : 0,
          "& fieldset": {
            borderColor: theme.palette.border.default,
          },
          "&:hover fieldset": {
            borderColor: theme.palette.border.strong,
          },
          "&.Mui-focused fieldset": {
            borderColor: theme.palette.primary.main,
            borderWidth: 1,
          },
        },
        "& .MuiInputBase-input": {
          boxSizing: "border-box",
          color: theme.palette.text.primary,
          fontSize: theme.typography.body2.fontSize,
          height: "auto",
          lineHeight: "20px",
          px: 2,
          py: "0 !important",
          "&::placeholder": {
            color: theme.palette.text.secondary,
            opacity: 1,
          },
        },
        "& .MuiInputAdornment-root": {
          alignItems: "center",
          color: theme.palette.text.secondary,
          height: "100%",
          m: 0,
          maxHeight: "none",
          mr: 1.5,
        },
        "& .MuiInputAdornment-root .MuiSvgIcon-root": {
          fontSize: 22,
        },
        "& .MuiSelect-select": {
          alignItems: "center",
          display: "flex",
          height: `${theme.product.field.filterHeight}px !important`,
          py: "0 !important",
        },
        ...(typeof sx === "function" ? sx(theme) : sx),
      })}
    >
      {children}
    </TextField>
  );
}
